import React, { useRef } from 'react';

const EMOJIS = ['⭐', '❤️', '👍', '✨', '🎉', '💫', '+1', '🎊', '🔥', '🥂', '🍻', '🍾', '🥳', '🎁'];
const PARTICLE_COUNT = 5;

function spawnParticles(rect) {
    for(let i = 0; i < PARTICLE_COUNT; i += 1) {
        const el = document.createElement('span');
        el.className = 'gamification-particle';
        el.textContent = EMOJIS[Math.floor(Math.random() * EMOJIS.length)];

        const x = rect.left + rect.width * 0.2 + Math.random() * rect.width * 0.6;
        const y = rect.top + rect.height * 0.4;
        const dx = (Math.random() - 0.5) * 24;
        const duration = 0.5 + Math.random() * 1.1;
        const rotate = (Math.random() - 0.5) * 70;
        const delay = (i / PARTICLE_COUNT) * 0.45 + Math.random() * 0.08;

        el.style.cssText = [
            `left:${x}px`,
            `top:${y}px`,
            `--particle-dx:${dx}px`,
            `--particle-duration:${duration}s`,
            `--particle-rotate:${rotate}deg`,
            'margin-left:-0.65rem',
            'margin-top:-0.65rem',
        ].join(';');

        setTimeout(() => {
            document.body.appendChild(el);
            setTimeout(() => el.remove(), duration * 1000 + 100);
        }, delay * 1000);
    }
}

function GamifiedButton({ children, onClick, className = '', as: Tag = 'button', ...props }) {
    const ref = useRef(null);

    const handleClick = e => {
        const el = ref.current;
        if(!el) return;

        const rect = el.getBoundingClientRect();

        el.classList.remove('is-clicked');
        void el.offsetWidth; // force reflow pour relancer l'animation
        el.classList.add('is-clicked');
        setTimeout(() => el.classList.remove('is-clicked'), 700);

        spawnParticles(rect);

        if(onClick) onClick(e);
    };

    return (
        <Tag ref={ref} className={`btn-gamified${className ? ` ${className}` : ''}`} onClick={handleClick} {...props}>
            {children}
        </Tag>
    );
}

export default GamifiedButton;
